import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DashboardLayout from "../DashboardLayout";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import AddEditForm from "./addEditForm";
import {
  fetchGamesListHP,
  fetchSectionById,
  getHomePageData,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import TournamentForm from "./tournamentForm";
import Header from "../../Components/Header";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import SortableItem from "./sortableItems";
import CategoryWiseForm from "./categoryWiseForm";
import PromotionForm from "./promotionForm";

// const SortableItem = ({ id, section, editSection }) => {
//   const {
//     attributes,
//     listeners,
//     setNodeRef,
//     transform,
//     transition,
//     isDragging,
//   } = useSortable({ id });

//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//     zIndex: isDragging ? 10 : 1,
//   };

//   return (
//     <div
//       ref={setNodeRef}
//       style={style}
//       className={`rounded-lg border-gray-200 dark:border-gray-700 bg-dark dark:bg-gray-800 shadow-sm ${
//         isDragging
//           ? "opacity-50 border-indigo-500 ring-2 ring-indigo-500/20"
//           : ""
//       }`}
//     >
//       <div className="d-flex align-items-center justify-content-between px-2 py-4 rounded-lg w-100 bg-dark my-2 border ">
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <div
//             {...attributes}
//             {...listeners}
//             className="cursor-grab active:cursor-grabbing p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
//           >
//             <svg
//               className="w-6 h-6 mx-2"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M4 8h16M4 16h16"
//               />
//             </svg>
//           </div>
//           <div className="mx-2">
//             <div className="d-flex flex-column">
//               <span className="text-light font-bold text-xl">
//                 {section.heading}
//               </span>
//               <span
//                 className="text-slate-500 font-bold"
//                 style={{ fontSize: "0.9rem" }}
//               >
//                 {section?.section_type.toUpperCase()}
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className="d-flex align-items-center">
//           <button
//             onClick={() => {
//               editSection(section);
//             }}
//             className="p-2 text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-md transition-colors"
//           >
//             Edit
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
const AddEditSection = () => {
  // const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  // const sec_type = searchParams.get("sec_type");
  const { sec_type, id } = Object.fromEntries(searchParams.entries());
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [sectionData, setSectionData] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [optionSelected, setOptionSelected] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gamesList, setGamesList] = useState([]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setSections((items) => {
        const oldIndex = items.findIndex((i) => i.id === active.id);
        const newIndex = items.findIndex((i) => i.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const getGames = async () => {
    const res = await fetchGamesListHP();
    if (res?.data?.success && res?.data.data) {
      setGamesList(res.data.data);
    }
  };

  const getSectionById = async () => {
    const res = await fetchSectionById(id);
    if (res?.data?.success && res.data?.data) {
      setSectionData(res.data.data);
      const { section_type } = res.data.data;
      setSelectedOption(section_type);
      setOptionSelected(true);
      setInitialLoading(false);
    } else {
      handleErrors(res, navigate, "Edit Section:");
    }
  };

  const getData = async () => {
    const res = await getHomePageData();
    if (res?.data?.success && res?.data?.data) {
      setSections(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
  };

  const handleEditSection = (sect) => {
    if (id) {
      setSearchParams({ id: sect.section_id });
      setSelectedOption(sect.section_type);
      setSectionData(sect);
    } else {
      setSearchParams({ sec_type: sect.section_type });
      setSelectedOption(sect.section_type);
      setSectionData(sect);
    }
  };

  useEffect(() => {
    getData();
    getGames();
  }, []);

  useEffect(() => {
    if (id) {
      setInitialLoading(true);
      getSectionById();
    }
    if (sec_type) {
      setSelectedOption(sec_type);
    }
  }, [id]);

  return (
    <div>
      <Header />
      <div className="row w-100 m-0" style={{ minHeight: "100vh" }}>
        <div
          className="col-sm-12 col-md-3 px-2 d-flex flex-column"
          style={{ minHeight: "100vh", borderRight: "1px solid gray" }}
        >
          <h3 className="mx-6 mt-2">Home Page Sections</h3>
          <hr className="w-100" />
          <div className="flex-1 overflow-y-auto px-6">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={sections.map((s) => s.id)}
                strategy={verticalListSortingStrategy}
              >
                {sections.length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    No sections added yet.
                  </div>
                ) : (
                  sections.map((section) => (
                    <SortableItem
                      key={section.id}
                      id={section.id}
                      section={section}
                      editSection={handleEditSection}
                    />
                  ))
                )}
              </SortableContext>
            </DndContext>
          </div>
        </div>
        <div className="col-sm-12 col-md-9">
          <div className="d-flex justify-content-between align-items-center pt-2">
            <h3>{selectedOption?.toUpperCase() || ""}</h3>
            <div className="d-flex align-items-center">
              {selectedOption && (
                <Button
                  variant="primary"
                  className="mx-2 px-4 py-2"
                  onClick={() => {
                    setSelectedOption("");
                    setSearchParams({});
                  }}
                >
                  Close
                </Button>
              )}
              <Button
                variant="danger"
                className="px-4 py-2"
                onClick={() => {
                  navigate("/home-page");
                }}
              >
                Exit
              </Button>
            </div>
          </div>
          <hr />
          {selectedOption === "tournament" ? (
            <TournamentForm
              id={id}
              selectedOption={selectedOption}
              navigate={navigate}
              gamesList={gamesList}
              sectionData={sectionData}
            />
          ) : selectedOption === "slider" || selectedOption === "game_list" ? (
            <AddEditForm
              id={id}
              selectedOption={selectedOption}
              navigate={navigate}
              gamesList={gamesList}
              sectionData={sectionData}
            />
          ) : selectedOption === "category_wise" ? (
            <CategoryWiseForm
              id={id}
              selectedOption={selectedOption}
              navigate={navigate}
              gamesList={gamesList}
              sectionData={sectionData}
            />
          ) : selectedOption === "promotion" ? (
            <PromotionForm
              id={id}
              selectedOption={selectedOption}
              navigate={navigate}
              gamesList={gamesList}
              sectionData={sectionData}
            />
          ) : (
            <div className="h-full flex items-center justify-center text-gray-500">
              <div className="text-center">
                <svg
                  className="w-16 h-16 mx-auto mb-4 text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                <p>Select a section to edit its properties</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddEditSection;
